import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Pagination } from "react-bootstrap";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import convertNumber from "../../helpers/convertNumber";
import "react-medium-image-zoom/dist/styles.css";
import convertTypeDepositWithdraw from "../../helpers/convertTypeDepositWithdraw";
import convertTypeActivityHistory from "../../helpers/convertTypeActivityHistory";
import ReactPaginate from "react-paginate";
import { get_activity_history_record } from "../../services/balance.service";
import { useStore } from "../../store";
import getOneLatest from "../../helpers/getOneLatest";
import LoadingComponent from "../LoadingComponent";
import converSex from "../../helpers/convertSex";

let limitData = 1;

export default function PopUpDetailActivityHistoryByBalance({
  open,
  onClose,
  data,
  onClickEdit,
  onClickDelete,
}) {
  // state
  const [dropdown, setDropdown] = useState(false);
  const [pagination, setPagination] = useState(1);
  const [totalPagination, setTotalPagination] = useState(0);
  const [activityHistoryRecordData, setActivityHistoryRecordData] = useState();
  const [selectActivityHistoryRecordData, setSelectActivityHistoryRecordData] =
    useState();
  // DONE: ເຮັດ loading
  const [isLoading, setIsLoading] = useState(false);

  // store
  const { token, branchData } = useStore();

  // useEffect
  useEffect(() => {
    setDropdown(false);
    setPagination(1);
  }, [open]);
  useEffect(() => {
    if (data) {
      getData();
    }
  }, [data, pagination]);

  // function
  const getData = async () => {
    try {
      setIsLoading(true);
      if (!data) throw new Error("data empty");
      if (!data?._id) throw new Error("activityHistoryId empty");

      let skipData = (pagination - 1) * limitData;
      const _data = await get_activity_history_record(
        data?._id,
        skipData,
        limitData,
        token
      );
      setActivityHistoryRecordData(_data);
      setTotalPagination(Math.ceil(_data?.total / limitData));

      setSelectActivityHistoryRecordData(getOneLatest(_data?.data));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error.message);
    }
  };


  return (
    <Modal show={open} onHide={onClose} size="sm" centered>
      {isLoading ? (
        <>
          <Modal.Header
            closeButton
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontWeight: 700,
            }}
          >
            <div>ລາຍລະອຽດ</div>
          </Modal.Header>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              minHeight: 400,
            }}
          >
            <LoadingComponent />
          </div>
        </>
      ) : (
        <>
          <Modal.Header
            closeButton
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontWeight: 700,
            }}
          >
            <div>ລາຍລະອຽດ</div>
            <div style={{ flex: 1 }}></div>
            {pagination === 1 ? (
              <div style={{ position: "relative" }}>
                <div
                  onClick={() => setDropdown((prev) => !prev)}
                  style={{
                    cursor: "pointer",
                    display: data?.isDelete ? "none" : "block",
                  }}
                >
                  <Icon
                    icon={"uil:ellipsis-h"}
                    style={{ width: 24, height: 24 }}
                  />
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: "0",
                    border: "1px solid rgba(0,0,0,0.1)",
                    boxShadow: "1px 1px 3px 5px rgba(0,0,0,0.025)",
                    borderRadius: 8,
                    minWidth: 100,
                    overflow: "hidden",
                    display: dropdown ? "block" : "none",
                    backgroundColor: "#fff",
                    zIndex: 1,
                  }}
                >
                  <ItemMenuButton
                    style={{
                      color: "#343A40",
                    }}
                    onClick={onClickEdit}
                  >
                    ແກ້ໄຂ
                  </ItemMenuButton>
                  <ItemMenuButton
                    style={{
                      color: "#FF0000",
                    }}
                    onClick={onClickDelete}
                  >
                    ລຶບ
                  </ItemMenuButton>
                </div>
              </div>
            ) : <div />}
          </Modal.Header>
          <Modal.Body
            style={{
              boxSizing: "border-box",
              overflow: "auto",
              width: "100%",
              padding: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 20,
              }}
            >
              {[
                {
                  title: "ຊື່ ແລະ ນາມສະກຸນ:",
                  value:
                    selectActivityHistoryRecordData?.memberId?.fullName || "-",
                },
                {
                  title: "ເພດ:",
                  value: selectActivityHistoryRecordData?.memberId?.gender
                    ? converSex(
                      selectActivityHistoryRecordData?.memberId?.gender
                    )
                    : "-",
                },
                {
                  title: "ປະເພດທຸລະກຳ:",
                  value: (
                    <div style={{ color: "#0178C1", fontWeight: 700 }}>
                      {selectActivityHistoryRecordData?.activityHistoryType
                        ? convertTypeDepositWithdraw(
                          selectActivityHistoryRecordData?.activityHistoryType
                        )
                        : "-"}
                    </div>
                  ),
                },
                {
                  title: "ຈຳນວນເງິນ (ກີບ):",
                  value: selectActivityHistoryRecordData?.balanceAmount
                    ? convertNumber(
                      selectActivityHistoryRecordData?.balanceAmount
                    )
                    : "-",
                },
                {
                  title: "ຍອດຄົງເຫຼືອກ່ອນໜ້າ (ກີບ):",
                  value: "-",
                },
                {
                  title: "ຍອດຄົງເຫຼືອ (ກີບ):",
                  value: selectActivityHistoryRecordData?.currentTotalBalance
                    ? convertNumber(
                      selectActivityHistoryRecordData?.currentTotalBalance
                    )
                    : "-",
                },
                {
                  title: "ຄະແນນ:",
                  value: selectActivityHistoryRecordData?.currentTotalPoint
                    ? convertNumber(
                      selectActivityHistoryRecordData?.currentTotalPoint
                    )
                    : "-",
                },
                {
                  title: "ລາຍລະອຽດ:",
                  value: selectActivityHistoryRecordData?.description || "-",
                },
                {
                  // DONE: ປະເພດ activity history delete
                  // DONE: ປະເພດ activity history update
                  title: "ປະເພດ:",
                  value: selectActivityHistoryRecordData?.activityManagementType
                    ? convertTypeActivityHistory(
                      selectActivityHistoryRecordData?.activityManagementType
                    )
                    : "-",
                },
                {
                  title: "ຜູ້ເຮັດທຸລະກຳ:",
                  value:
                    selectActivityHistoryRecordData?.createdBy?.fullName || "-",
                },
              ].map((e, i) => (
                <div className="list-data" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
            {/* DONE: ປະຫວັດການແກ້ໄຂ ແລະ ປະຫວັດການລົບ */}
          </Modal.Body>
        </>
      )}
      <Modal.Footer>
        <div
          style={{
            display: isLoading ? "none" : "flex",
            justifyContent: "center",
            width: "100%",
            bottom: 20,
          }}
        >
          <ReactPaginate
            previousLabel={
              <span className="glyphicon glyphicon-chevron-left">{`<`}</span>
            }
            nextLabel={
              <span className="glyphicon glyphicon-chevron-right">{`>`}</span>
            }
            breakLabel={<Pagination.Item disabled>...</Pagination.Item>}
            breakClassName={"break-me"}
            pageCount={totalPagination} // Replace with the actual number of pages
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={(e) => {
              setPagination(e?.selected + 1);
            }}
            containerClassName={"pagination justify-content-center"} // Bootstrap class for centering
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
}

const ItemMenuButton = styled("div")({
  padding: 10,
  color: "#FF0000",
  cursor: "pointer",
  width: "100%",
  zIndex: 1,
  position: "relative",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.05)",
  },
});
